import axios from "axios";

let API_URL = process.env.REACT_APP_API_URL;
API_URL = API_URL + "purchase-return";

class PurchaseReturn {
  create = async (val: any) => {
    await axios({
      method: "post",
      url: `${API_URL}`,
      data: val,
    }).catch((e) => {
      const { message } = e.response.data;
      if (message.errorInfo) throw message.errorInfo[2];
      else throw e.message;
    });
  };
  edit = async (val: any, code: any) => {
    await axios({
      method: "put",
      url: `${API_URL}/${code}`,
      data: val,
    }).catch((e) => {
      const { message } = e.response.data;
      if (message.errorInfo) throw message.errorInfo[2];
      else throw e.message;
    });
  };
  get = async (code: any) => {
    const response = await axios.get<any>(`${API_URL}/${code}`,
    ).catch((e) => {
      throw e.message;
    });
    return response.data.purchaseReturn;
  };
  getAll = async () => {
    const response = await axios.get<any>(`${API_URL}`,
    ).catch((e) => {
      throw e.message;
    });
    return response.data.purchaseReturns;
  };

  reversal = async (code: any) => {
    const response = await axios({
      method: "put",
      url: `${API_URL}-reversal`,
      data: code
    }).catch((e) => {
      throw e.message;
    });
    return response.data;
  };
  // search = async (keyword: any) => {
  //   const response = await axios({
  //     method: "get",
  //     url: `${API_URL}SalesReturn-search/${keyword}`,
  //   }).catch((e) => {
  //     throw e.message;
  //   });
  //   return response.data.SalesReturn;
  // };
}
export default new PurchaseReturn();
